import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { ordersAPI } from '../../services/api';

export const CheckoutContact = ({ user, email, setEmail, createAccount, setCreateAccount, password, setPassword, exists, setExists }) => {
  const [checking, setChecking] = useState(false);
  useEffect(() => {
    setExists(false);
    if (user || !createAccount || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;
    let active = true;
    const timer = setTimeout(async () => {
      setChecking(true);
      try { const result = await ordersAPI.checkAccount(email); if (active) setExists(result.exists); }
      catch { /* The order endpoint repeats the check and never blocks guest checkout. */ }
      finally { if (active) setChecking(false); }
    }, 350);
    return () => { active = false; clearTimeout(timer); };
  }, [email, createAccount, user, setExists]);
  return <div className="space-y-4 pb-5 mb-5 border-b" data-testid="checkout-contact">
    <div><Label htmlFor="checkout-email">Correo electrónico *</Label>
      <Input id="checkout-email" type="email" autoComplete="email" required value={email} onChange={e => setEmail(e.target.value)} data-testid="checkout-email" placeholder="tu@correo.com" /></div>
    {!user && <>
      <label className="flex items-start gap-3 text-sm cursor-pointer" htmlFor="create-checkout-account">
        <input id="create-checkout-account" type="checkbox" checked={createAccount} onChange={e => { setCreateAccount(e.target.checked); if (!e.target.checked) setPassword(''); }} className="mt-0.5 accent-orange-500 w-4 h-4 shrink-0" data-testid="checkout-create-account" />
        ¿Crear cuenta para mis próximas compras?
      </label>
      {createAccount && <div>
        <Label htmlFor="checkout-password">Contraseña</Label>
        <Input id="checkout-password" type="password" autoComplete="new-password" minLength={8} maxLength={72} value={password} disabled={exists} onChange={e => setPassword(e.target.value)} data-testid="checkout-password" placeholder="Mínimo 8 caracteres" />
      </div>}
      {checking && <p className="text-xs text-gray-500" data-testid="checkout-checking-email">Comprobando correo…</p>}
      {exists && <p className="text-sm text-amber-800 bg-amber-50 p-3 rounded-md" role="status" data-testid="checkout-existing-email">
        Este correo ya tiene cuenta. <Link to="/login?redirect=/checkout" className="underline font-semibold" data-testid="checkout-login-link">Inicia sesión</Link> o continúa como invitado, sin cambiar tu contraseña.
      </p>}
    </>}
  </div>;
};